<vtmn-play-icon
  *ngIf="iconType || leftIconType"
  [name]="iconType || leftIconType"
  class="button__left-icon"
  [ariaLabel]="ariaLabel"
></vtmn-play-icon>
<ng-content *ngIf="!iconType"></ng-content>
<vtmn-play-icon
  *ngIf="!iconType && rightIconType"
  [name]="rightIconType"
  class="button__right-icon"
  [ariaLabel]="ariaLabel"
></vtmn-play-icon>
